import {config} from "../../../../definitions/TimelineItems";
import classnames from "classnames";
import {TimelineFrameHeaderEventIcon} from "./TimelineFrameHeaderEventIcon";
import TimelineFrameHeaderEventTitle from "./TimelineFrameHeaderEventTitle";
import {TimelineFrameDataContext} from "../../TimelineFramePage";
import {useContext} from "react";
import {OTLink} from "../../../../components/tag/OTLink";

export const TimelineFrameHeader = () => {
    const { data } = useContext(TimelineFrameDataContext);
    let { color } = {...config[data.type]};

    // This is default if none found
    if (!color) {
        color = 'blue';
    }

    return (
        <>

            <div className={classnames("timeline-header-container", [color])}>
                <TimelineFrameHeaderNav />
                <TimelineFrameHeaderContent />
            </div>
        </>
    );
};

const TimelineFrameHeaderNav = () => {
    return (
        <div className="timeline-frame-header-nav-container">
            <OTLink link={`/timeline`}>
                <span>{'< Minun hoitoni'}</span>
            </OTLink>
        </div>
    );
};

const TimelineFrameHeaderContent = () => {
    const { data, linkkipalvelu, past } = useContext(TimelineFrameDataContext);
    return (
        <div className={'timeline-header-content-container'}>
            <div style={{boxSizing: "border-box"}}>
                <TimelineFrameHeaderEventIcon data={data} />
                <TimelineFrameHeaderEventTitle data={data} linkkipalvelu={linkkipalvelu} past={past} />
            </div>
        </div>
    );
};